import api from '../../api';
import config from '../../config/server-config';
import { API_CALL_SUCCESSFULL } from '../../constants/NumberConstants';
import { ERROR_MESSAGES } from './currency.constants';
import { currencyCodeSchema, saveCurrencyResponseSchema } from './currency.validation';
import type { SaveCurrencyResponse } from '../../../shared/types/currency';

export const getCurrenciesCGI = async (): Promise<unknown> => {
  try {
    const response = await api.get(config.GetCurrenciesCGI);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
    return null;
  } catch {
    return null;
  }
};

const saveToCGI = async (currencyCode: string): Promise<SaveCurrencyResponse> => {
  try {
    const response = await api.post(config.SaveCurrencyPreferenceCGI, { currency: currencyCode });

    const succeeded =
      response.status === API_CALL_SUCCESSFULL &&
      (response.data?.success !== false || typeof response.data?.success === 'undefined');

    if (!succeeded) {
      return { success: false, error: ERROR_MESSAGES.NOT_AVAILABLE };
    }

    return { success: true, data: { currencyCode, cgi: response.data?.data ?? null, dmi: null } };
  } catch {
    return { success: false, error: ERROR_MESSAGES.SAVE_FAILED };
  }
};

export const saveToDMI = async (currencyCode: string): Promise<SaveCurrencyResponse> => {
  try {
    const response = await api.post(config.SaveCurrencyPreferenceDMI, { currencyCode });

    const succeeded =
      response.status === API_CALL_SUCCESSFULL &&
      (response.data?.success !== false || typeof response.data?.success === 'undefined');

    if (!succeeded) {
      return { success: false, error: ERROR_MESSAGES.PARTIAL_SAVE };
    }

    return { success: true, data: { currencyCode, dmi: response.data?.data ?? null, cgi: null } };
  } catch {
    return { success: false, error: ERROR_MESSAGES.PARTIAL_SAVE };
  }
};

export const saveCurrencyPreference = async (currencyCode: string): Promise<SaveCurrencyResponse> => {
  try {
    const validated = currencyCodeSchema.parse(currencyCode);

    const cgiResult = await saveToCGI(validated);
    if (!cgiResult.success) {
      return cgiResult;
    }

    const dmiResult = await saveToDMI(validated);
    if (!dmiResult.success) {
      return dmiResult;
    }

    return saveCurrencyResponseSchema.parse({
      success: true,
      data: {
        currencyCode: validated,
        dmi: dmiResult.data?.dmi ?? null,
        cgi: cgiResult.data?.cgi ?? null,
      },
    });
  } catch {
    return { success: false, error: ERROR_MESSAGES.SAVE_FAILED };
  }
};
